import { memo } from 'react';

import dayjs, { Dayjs } from 'dayjs';

import { cn } from '@/lib/utils';

/**
 * Lightweight cell rendered synchronously on mount — just the border/background div.
 * No tooltip, no translation, no utilization text.
 * The full TimelineCell with tooltips and data is rendered in the deferred phase.
 */
export const TimelineCellShell = memo(
  ({
    date,
    cellWidth,
    height,
    disabled,
  }: {
    date: Dayjs;
    cellWidth: number;
    height: number;
    disabled?: boolean;
  }) => {
    const isWeekend = date.day() === 0 || date.day() === 6;
    const isToday = date.isSame(dayjs(), 'day');
    const isLastDayOfMonth = date.endOf('month').isSame(date, 'day');

    return (
      <div
        className={cn('relative overflow-hidden border-b border-r', {
          'pointer-events-none bg-border/60': disabled,
          'pointer-events-none bg-muted/50': isWeekend && !disabled,
          'border-r-2': isLastDayOfMonth,
          'bg-green-50 dark:bg-green-950': isToday,
        })}
        style={{
          width: `${cellWidth}rem`,
          minWidth: `${cellWidth}rem`,
          height,
        }}
      />
    );
  }
);
